import { ErrorCodes } from './ErrorCodes';

export class PlaybackError extends Error {
  name: string;
  code: ErrorCodes;

  constructor(code: ErrorCodes = ErrorCodes.DEFAULT, message?: string) {
    super();
    this.name = 'Playback API Error';
    this.message = `Playback API Error (Code: ${code})${message ? `: ${message}` : ''}`;
    this.code = code;
    console.error(this);
  }
}
